import React, { useState } from 'react'
import { useTheme } from '../ThemeContext'

export default function PromptDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  placeholder = '',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  expectedValue = null
}) {
  const { darkMode } = useTheme()
  const [inputValue, setInputValue] = useState('')

  if (!isOpen) return null

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
      setInputValue('')
    }
  }

  const handleConfirm = () => {
    onConfirm(inputValue)
    setInputValue('')
  }

  const handleCancel = () => {
    onClose()
    setInputValue('')
  }

  const isConfirmEnabled = expectedValue
    ? inputValue === expectedValue
    : inputValue.trim() !== ''

  return (
    <div
      onClick={handleBackdropClick}
      style={{
        position: 'fixed', inset: 0, zIndex: 1100,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '1rem',
        backgroundColor: 'rgba(0,0,0,0.5)'
      }}
    >
      <div style={{
        backgroundColor: darkMode ? '#1e2d3d' : '#ffffff',
        borderRadius: '12px',
        boxShadow: darkMode ? '0 20px 60px rgba(0,0,0,0.6)' : '0 20px 60px rgba(0,0,0,0.2)',
        maxWidth: '440px',
        width: '100%',
        padding: '1.5rem',
        border: darkMode ? '1px solid rgba(90,127,173,0.2)' : '1px solid rgba(0,0,0,0.08)'
      }}>
        {title && (
          <h3 style={{ margin: '0 0 0.75rem', fontSize: '1.1rem', fontWeight: '700', color: darkMode ? '#c8daf5' : '#1a2a3e' }}>
            {title}
          </h3>
        )}
        <div style={{ marginBottom: '1rem', fontSize: '0.9rem', color: darkMode ? '#7aa0c8' : '#4a6080', whiteSpace: 'pre-line', lineHeight: 1.5 }}>
          {message}
        </div>
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder={placeholder}
          autoFocus
          onKeyDown={(e) => {
            if (e.key === 'Enter' && isConfirmEnabled) handleConfirm()
            else if (e.key === 'Escape') handleCancel()
          }}
          style={{
            width: '100%',
            padding: '0.75rem 1rem',
            marginBottom: '1.5rem',
            border: `2px solid ${darkMode ? 'rgba(90,127,173,0.4)' : '#d1d5db'}`,
            borderRadius: '8px',
            backgroundColor: darkMode ? 'rgba(255,255,255,0.05)' : '#f9fafb',
            color: darkMode ? '#c8daf5' : '#1a2a3e',
            fontSize: '0.9rem',
            outline: 'none'
          }}
        />
        <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
          <button
            onClick={handleCancel}
            style={{
              padding: '0.5rem 1rem',
              border: `1px solid ${darkMode ? 'rgba(90,127,173,0.3)' : '#d1d5db'}`,
              borderRadius: '8px',
              backgroundColor: 'transparent',
              color: darkMode ? '#7aa0c8' : '#374151',
              fontWeight: '600',
              fontSize: '0.875rem',
              cursor: 'pointer'
            }}
          >
            {cancelText}
          </button>
          <button
            onClick={handleConfirm}
            disabled={!isConfirmEnabled}
            style={{
              padding: '0.5rem 1rem',
              border: 'none',
              borderRadius: '8px',
              backgroundColor: isConfirmEnabled ? '#dc2626' : (darkMode ? 'rgba(90,127,173,0.2)' : '#d1d5db'),
              color: isConfirmEnabled ? 'white' : (darkMode ? '#7aa0c8' : '#9ca3af'),
              fontWeight: '600',
              fontSize: '0.875rem',
              cursor: isConfirmEnabled ? 'pointer' : 'not-allowed'
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  )
}
